export const Experiments: Record<string, number> = {
    LYNXES_IDENTIFICATION_AUTOSHOW_MODAL: 4796,
    LYNXES_IDENTIFICATION_RESET_PASSWORD_STEP: 4833,
    LYNXES_IDENTIFICATION_AUTOSHOW_MODAL_V2: 4836,
};
